if (!customElements.get('benefit-accordion')) {
  customElements.define(
    'benefit-accordion',
    class BenefitAccordion extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-benefit-trigger]'));
        this.panel = this.querySelector('[data-benefit-panel-container]');
        this.panels = Array.from(this.querySelectorAll('[data-benefit-panel]'));

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.toggle(button));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const button = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (button) this.open(button);
        });
      }

      toggle(button) {
        if (button.getAttribute('aria-expanded') === 'true') {
          this.close();
          return;
        }

        this.open(button);
      }

      open(button) {
        const blockId = button.dataset.blockId;

        this.buttons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-expanded', `${isActive}`);
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.benefitPanel !== blockId;
        });

        this.panel.classList.add('is-open');
        this.panel.setAttribute('aria-hidden', 'false');
      }

      close() {
        this.buttons.forEach((button) => {
          button.classList.remove('is-active');
          button.setAttribute('aria-expanded', 'false');
        });
        this.panel.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
      }
    }
  );
}
